// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"d016b0cd","537":"dad13d9a","660":"03c3e641"}[chunkId] + ".chunk.css";
};